import {
  ca,
  cs,
  da,
  de,
  deAT,
  enAU,
  enCA,
  enGB,
  enIE,
  enIN,
  enNZ,
  enUS,
  es,
  eu,
  fi,
  fr,
  frCA,
  frCH,
  gl,
  hr,
  hu,
  it,
  itCH,
  ja,
  ko,
  nb,
  nl,
  nlBE,
  pl,
  pt,
  ro,
  sk,
  sl,
  sv,
} from 'date-fns/locale';

import sr from 'date-fns/locale/sr-Latn';

export const LOCALES = {
  ca,
  cs,
  da,
  de,
  deAT,
  enAU,
  enCA,
  enGB,
  enIE,
  enIN,
  enNZ,
  enUS,
  es,
  eu,
  fi,
  fr,
  frCA,
  frCH,
  gl,
  hr,
  hu,
  it,
  itCH,
  ja,
  ko,
  nb,
  nl,
  nlBE,
  pl,
  pt,
  ro,
  sk,
  sl,
  sr,
  sv,
};
